import { useEffect } from 'react';
import {
	FieldPath,
	FieldValues,
	useController,
	useFormContext,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useProductCenterCountries } from 'library/hooks/useProductCenterCountries';

import { CountryInput, CountryInputProps } from './CountryInput';

export const ProductCenterCountryInput = <
	TFieldValues extends FieldValues = FieldValues,
	TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
	props: CountryInputProps<TFieldValues, TName>
) => {
	const { clearErrors, control, setError } = useFormContext<TFieldValues>();
	const {
		field: { value },
		fieldState: { error },
	} = useController({
		name: props.name,
		control,
	});
	const { t } = useTranslation(['error']);
	const { countryOptionsWithUS, excludedCountries } =
		useProductCenterCountries();

	useEffect(() => {
		const message = t('error:excluded-country-error');
		if (excludedCountries.includes(value)) {
			setError(props.name, { type: 'manual', message });
		} else if (error?.message === message) {
			clearErrors(props.name);
		}
	}, [value, excludedCountries, error, props.name, clearErrors, setError, t]);

	return <CountryInput {...props} options={countryOptionsWithUS} />;
};
